import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { IdeasService } from '../../services/ideas/ideas.service';

export function useIdeas(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['ideas', 'list', params],
    queryFn: () => IdeasService.list(params),
    enabled: false,
  });
}

export function useIdeaDetails(id: string | number) {
  return useQuery({
    queryKey: ['ideas', 'details', id],
    queryFn: () => IdeasService.getById(id),
    enabled: !!id,
  });
}

export function useCreateIdea() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => IdeasService.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['ideas', 'list'] });
    },
  });
}

export function useIdeaDashboard(id: string | number) {
  return useQuery({
    queryKey: ['ideas', 'dashboard', id],
    queryFn: () => IdeasService.getDashboard(id),
    enabled: !!id,
  });
}

export function useUpdateIdea() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string | number; data: any }) => IdeasService.update(id, data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['ideas', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['ideas', 'details', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['ideas', 'dashboard', variables.id] });
    },
  });
}

export function useDeleteIdea() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string | number) => IdeasService.delete(id),
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ['ideas', 'list'] });
      queryClient.invalidateQueries({ queryKey: ['ideas', 'details', id] });
      queryClient.invalidateQueries({ queryKey: ['ideas', 'dashboard', id] });
    },
  });
}
